<div class="contents">
  <app-back-button></app-back-button>
  <div class="custom-modal-layout mt-3">
    <form class="container basis-[50rem] p-5 pb-4 background-white" (ngSubmit)="save()">
      <div class="modal-header" style="margin-bottom: 10px !important;">
        <div class="icon">
          <img src="icons/plus-circle.svg" alt="Email Icon" />
        </div>
        <span class="title">Cadastro de Estudante</span>
      </div>

      <div class="basis-[50rem]">
        <form [formGroup]="personalInfoForm">
          <div class="p-fluid grid">
            <article class="inst-learn col-12">
              <h5>Informações Pessoais</h5>
              <span></span>
            </article>
            <div class="field col-12">
              <div class="file-upload">
                <p-fileupload name="myfile[]" (onSelect)="onSelectedFiles($event)" [multiple]="false"
                  accept="image/png, image/jpeg, image/jpg" maxFileSize="2000000000"
                  invalidFileTypeMessageSummary="danger"
                  invalidFileTypeMessageDetail="O Ficheiro seleccionado é inválido"
                  invalidFileLimitMessageSummary="danger"
                  invalidFileLimitMessageDetail="Ficheiro muito grande. Min: 2MB">
                  <ng-template #header let-files let-chooseCallback="chooseCallback" let-clearCallback="clearCallback"
                    let-uploadCallback="uploadCallback">
                  </ng-template>
                  <ng-template #content let-files let-uploadedFiles="uploadedFiles"
                    let-removeFileCallback="removeFileCallback" let-chooseCallback="chooseCallback"
                    let-removeUploadedFileCallback="removeUploadedFileCallback">
                    <a class="circular-upload preview"
                      [ngStyle]="{ 'background-image': imagePreview ? 'url(' + imagePreview + ')' : 'none' }">
                      <span *ngIf="!imagePreview">Foto</span>
                      <div class="icon" (click)="choose($event, chooseCallback)">
                        <img src="icons/camera-01.svg" alt="">
                      </div>
                    </a>
                    <!-- <button pButton type="button" label="Guardar Foto" class="p-button-primary mt-2" (click)="savePhoto()"></button> -->
                  </ng-template>
                  <ng-template #file></ng-template>
                  <ng-template #empty></ng-template>
                </p-fileupload>
              </div>
            </div>
            <div class="field col-6">
              <label for="numeroBI">Número Bilhete de Identidade*</label>
              <div class="flex align-items-center relative">
                <input id="numeroBI" type="search" class="w-full" pInputText formControlName="numeroBI"
                  placeholder="Informe o número do BI" />
                <button pButton type="button" icon="pi pi-search" class="search-btn"
                  [disabled]="personalInfoForm.get('numeroBI')?.invalid" (click)="searchDocumentNumber()"
                  aria-label="Search"></button>
              </div>
              <div *ngIf="personalInfoForm.get('numeroBI')?.touched && personalInfoForm.get('numeroBI')?.invalid">
                <small class="error-message" *ngIf="personalInfoForm.get('numeroBI')?.errors?.['required']">Número
                  Bilhete de Identidade é obrigatório.</small>
              </div>
            </div>
            <div class="field col-6">
              <label for="nome">Nome do Estudante</label>
              <input id="nome" type="text" class="w-full" pInputText formControlName="nome"
                placeholder="Nome do estudante" />
              <div *ngIf="personalInfoForm.get('nome')?.touched && personalInfoForm.get('nome')?.invalid">
                <small class="error-message" *ngIf="personalInfoForm.get('nome')?.errors?.['required']">Nome do
                  estudante é obrigatório.</small>
              </div>
            </div>
            <div class="field col-3">
              <label for="dataEmissaoBI">Data de Emissão</label>
              <p-datepicker [iconDisplay]="'input'" [showIcon]="true" inputId="icondisplay"
                placeholder="Seleccione a data" dateFormat="dd/mm/yy" id="dataEmissaoBI" class="date-camp w-full d-grid"
                formControlName="dataEmissaoBI" />
              <div
                *ngIf="personalInfoForm.get('dataEmissaoBI')?.touched && personalInfoForm.get('dataEmissaoBI')?.invalid">
                <small class="error-message" *ngIf="personalInfoForm.get('dataEmissaoBI')?.errors?.['required']">Data de
                  Emissão é
                  obrigatório.</small>
              </div>
            </div>
            <div class="field col-3">
              <label for="dataVencimentoBI">Data de Vencimento</label>
              <p-datepicker [iconDisplay]="'input'" [showIcon]="true" inputId="icondisplay"
                placeholder="Seleccione a data" dateFormat="dd/mm/yy" id="dataVencimentoBI"
                class="date-camp w-full d-grid" formControlName="dataVencimentoBI" />
              <div
                *ngIf="personalInfoForm.get('dataVencimentoBI')?.touched && personalInfoForm.get('dataVencimentoBI')?.invalid">
                <small class="error-message" *ngIf="personalInfoForm.get('dataVencimentoBI')?.errors?.['required']">Data
                  de Vencimento é
                  obrigatório.</small>
              </div>
              <div *ngIf="personalInfoForm.hasError('dataEmissaVencimentoRange')" class="error-message">
                <small class="error-message">Data de Vencimento deve ser superior que a Data de Emissão.</small>
              </div>
            </div>
            <div class="field col-6">
              <label for="dataNascimento">Data de Nascimento</label>
              <p-datepicker [iconDisplay]="'input'" [showIcon]="true" inputId="icondisplay"
                placeholder="Seleccione a data" dateFormat="dd/mm/yy" id="dataNascimento"
                class="date-camp w-full d-grid" formControlName="dataNascimento" />
              <div
                *ngIf="personalInfoForm.get('dataNascimento')?.touched && personalInfoForm.get('dataNascimento')?.invalid">
                <small class="error-message" *ngIf="personalInfoForm.get('dataNascimento')?.errors?.['required']">Data
                  de Nascimento é
                  obrigatório.</small>
                <small class="error-message"
                  *ngIf="personalInfoForm.get('dataNascimento')?.errors?.['idadeMinima']">Idade mínima é 15
                  anos.</small>
              </div>
              <!-- <div *ngIf="personalInfoForm.hasError('dateRange')" class="error-message">
                <small class="error-message">Data de Vencimento deve ser maior que a Data de Emissão.</small>
              </div> -->
            </div>
            <div class="field col-3">
              <label for="genero">Género</label>
              <p-select id="genero" class="w-full" [filter]="true" [options]="generoOptions" optionLabel="designacao"
                optionValue="id" placeholder="Seleccione o género" formControlName="genero" />
              <div *ngIf="personalInfoForm.get('genero')?.touched && personalInfoForm.get('genero')?.invalid">
                <small class="error-message" *ngIf="personalInfoForm.get('genero')?.errors?.['required']">Gênero é
                  obrigatório.</small>
              </div>
            </div>
            <div class="field col-3">
              <label for="estadoCivil">Estado Civil</label>
              <p-select id="estadoCivil" [filter]="true" class="w-full" [options]="estadoCivilOptions"
                optionLabel="designacao" optionValue="id" placeholder="Seleccione o estado civil"
                formControlName="estadoCivil" />
              <div *ngIf="personalInfoForm.get('estadoCivil')?.touched && personalInfoForm.get('estadoCivil')?.invalid">
                <small class="error-message" *ngIf="personalInfoForm.get('estadoCivil')?.errors?.['required']">Estado
                  Civil é
                  obrigatório.</small>
              </div>
            </div>
            <div class="field col-6">
              <label for="nivelAcademicoID">Nível Académico Actual</label>
              <p-select id="nivelAcademicoID" [filter]="true" class="w-full" [options]="nivelAcademicoOptions"
                optionLabel="designacao" optionValue="id" placeholder="Seleccione o nível académico"
                formControlName="nivelAcademicoID" />
              <div
                *ngIf="personalInfoForm.get('nivelAcademicoID')?.touched && personalInfoForm.get('nivelAcademicoID')?.invalid">
                <small class="error-message"
                  *ngIf="personalInfoForm.get('nivelAcademicoID')?.errors?.['required']">Nível
                  Académico é
                  obrigatório.</small>
              </div>
            </div>

            <article class="inst-learn col-12">
              <h5>Filiação</h5>
              <span class="w-full"></span>
            </article>

            <div class="field col-6">
              <label for="nomePai">Nome do Pai</label>
              <input id="nomePai" type="text" class="w-full" pInputText formControlName="nomePai"
                placeholder="Nome do pai" />
              <div *ngIf="personalInfoForm.get('nomePai')?.touched && personalInfoForm.get('nomePai')?.invalid">
                <small class="error-message" *ngIf="personalInfoForm.get('nomePai')?.errors?.['required']">Nome do
                  Pai é obrigatório.</small>
              </div>
            </div>
            <div class="field col-6">
              <label for="nomeMae">Nome da Mãe</label>
              <input id="nomeMae" type="text" class="w-full" pInputText formControlName="nomeMae"
                placeholder="Nome da mãe" />
              <div *ngIf="personalInfoForm.get('nomeMae')?.touched && personalInfoForm.get('nomeMae')?.invalid">
                <small class="error-message" *ngIf="personalInfoForm.get('nomeMae')?.errors?.['required']">Nome da
                  Mãe é obrigatório.</small>
              </div>
            </div>
            <article class="inst-learn col-12">
              <h5>Morada</h5>
              <span></span>
            </article>
            <div class="field col-6">
              <label for="pais">País </label>
              <p-select id="pais" [filter]="true" class="w-full" [options]="countries" optionLabel="designacao"
                optionValue="id" placeholder="Seleccione o país" formControlName="paisNascimento" />
              <div
                *ngIf="personalInfoForm.get('paisNascimento')?.touched && personalInfoForm.get('paisNascimento')?.invalid">
                <small class="error-message" *ngIf="personalInfoForm.get('paisNascimento')?.errors?.['required']">
                  País é
                  obrigatório.</small>
              </div>
            </div>
            <div class="field col-6">
              <label for="provincia">Província </label>
              <p-select id="provincia" [filter]="true" class="w-full" [options]="provinces" optionLabel="designacao"
                optionValue="id" placeholder="Seleccione a província" formControlName="idProvinciaResidencia" />
              <div
                *ngIf="personalInfoForm.get('idProvinciaResidencia')?.touched && personalInfoForm.get('idProvinciaResidencia')?.invalid">
                <small class="error-message"
                  *ngIf="personalInfoForm.get('idProvinciaResidencia')?.errors?.['required']">Província de
                  Residência é obrigatório.</small>
              </div>
            </div>
            <div class="field col-6">
              <label for="município">Município </label>
              <p-select id="município" [filter]="true" class="w-full" [options]="municipalities"
                optionLabel="designacao" optionValue="id" placeholder="Seleccione o município"
                formControlName="idMunicipioResidencia" />
              <div
                *ngIf="personalInfoForm.get('idMunicipioResidencia')?.touched && personalInfoForm.get('idMunicipioResidencia')?.invalid">
                <small class="error-message"
                  *ngIf="personalInfoForm.get('idMunicipioResidencia')?.errors?.['required']">Município de
                  Residência é obrigatório.</small>
              </div>
            </div>
            <div class="field col-6">
              <label for="endereco">Endereço atual</label>
              <input id="endereco" type="text" class="w-full" pInputText formControlName="enderecoResidencia"
                placeholder="Endereço" />
              <div
                *ngIf="personalInfoForm.get('enderecoResidencia')?.touched && personalInfoForm.get('enderecoResidencia')?.invalid">
                <small class="error-message"
                  *ngIf="personalInfoForm.get('enderecoResidencia')?.errors?.['required']">Endereço é
                  obrigatório.</small>
                <small class="error-message" *ngIf="personalInfoForm.get('enderecoResidencia')?.errors?.['minlength']">
                  Endereço deve ter no mínimo 5 caracteres.
                </small>
              </div>
            </div>

            <article class="inst-learn col-12">
              <h5>Dados do Contacto</h5>
              <span></span>
            </article>
            <div class="field col-6">
              <label for="email">Email</label>
              <input id="email" type="text" class="w-full" pInputText formControlName="email" placeholder="Email" />
              <div *ngIf="personalInfoForm.get('email')?.touched && personalInfoForm.get('email')?.invalid">
                <small class="error-message" *ngIf="personalInfoForm.get('email')?.errors?.['required']">Email é
                  obrigatório.</small>
                <small class="error-message" *ngIf="personalInfoForm.get('email')?.errors?.['email']">Email
                  inválido.</small>
              </div>
            </div>
            <div class="field col-6 d-flex flex-column">
              <label for="contactoPrincipal">Contacto Principal</label>
              <p-inputmask id="contactoPrincipal" mask="+244 999 999 999" class="w-full d-contents" pInputText
                formControlName="contactoPrincipal" placeholder="+244 999 999 000" />
              <div
                *ngIf="personalInfoForm.get('contactoPrincipal')?.touched && personalInfoForm.get('contactoPrincipal')?.invalid">
                <small class="error-message"
                  *ngIf="personalInfoForm.get('contactoPrincipal')?.errors?.['required']">Contacto Principal é
                  obrigatório.</small>
              </div>
            </div>

            <div class="field col-6 d-flex flex-column">
              <label for="contactoSecundario">Contacto Secundário</label>
              <p-inputmask id="contactoSecundario" mask="+244 999 999 999" class="w-full d-contents" pInputText
                formControlName="contactoSecundario" placeholder="+244 999 999 000" />
            </div>

            <div class="field col-6 d-flex flex-column">
              <label for="contactoFamiliar">Contacto Familiar</label>
              <p-inputmask id="contactoFamiliar" mask="+244 999 999 999" class="w-full d-contents" pInputText
                formControlName="contactoFamiliar" placeholder="+244 999 999 000" />
              <div
                *ngIf="personalInfoForm.get('contactoFamiliar')?.touched && personalInfoForm.get('contactoFamiliar')?.invalid">
                <small class="error-message"
                  *ngIf="personalInfoForm.get('contactoFamiliar')?.errors?.['required']">Contacto Familiar é
                  obrigatório.</small>
              </div>
            </div>

            <article class="inst-learn col-12">
              <h5>Dados Bancários</h5>
              <span class="w-full" style="width: 75% !important; margin-left: 15px;"></span>
            </article>

            <div class="field col-6 d-flex flex-column">
              <label for="Banco">Banco</label>
              <input id="Banco" type="text" class="w-full" pInputText formControlName="Banco"
                placeholder="Nome do Banco" />
            </div>

            <div class="field col-6 d-flex flex-column">
              <label for="Iban">Nº de Identificação Bancária (IBAN)</label>
              <input id="Iban" type="text" class="w-full" pInputText formControlName="Iban"
                placeholder="AO06 0000 0000 0000 0000 0" />
            </div>

            <div class="field col-6 d-flex flex-column">
              <label for="NumeroConta">Nº de Conta</label>
              <input id="NumeroConta" type="text" class="w-full" pInputText formControlName="NumeroConta"
                placeholder="Número da Conta" />
            </div>

            <div class="field col-6 d-flex flex-column">
              <label for="Swift">Código SWIFT</label>
              <input id="Swift" type="text" class="w-full" pInputText formControlName="Swift"
                placeholder="Código SWIFT" />
            </div>

            <!--
            <div class="field col-12" style="display: none;">
              <label>Activar Bolseiro?</label>
              <div class="flex flex-wrap gap-4">
                <div class="flex items-center">
                  <p-radioButton name="isActive" [value]="true" formControlName="isActive"
                    inputId="isActive1"></p-radioButton>
                  <label for="isActive1" class="ml-2">Sim</label>
                </div>
                <div class="flex items-center">
                  <p-radioButton name="isActive" [value]="false" formControlName="isActive"
                    inputId="isActive2"></p-radioButton>
                  <label for="isActive2" class="ml-2">Não</label>
                </div>
              </div>
            </div> -->

          </div>
        </form>
      </div>

      <div class="modal-footer" style="margin-top: 5px !important;">
        <button pButton type="button" label="Cancelar" class="p-button-secondary" (click)="resetForm()"></button>
        <!-- <button pButton type="button" label="Próximo" class="p-button-primary"></button> -->
        <button pButton type="submit" class="p-button-primary" (click)="save()" [disabled]="isLoading">
          <ng-container *ngIf="isLoading; else saveLabel">
            <i class="pi pi-spin pi-spinner"></i> Guardando...
          </ng-container>
          <ng-template #saveLabel>{{bolseiroId ? 'Actualizar' : 'Cadastrar'}} Estudante</ng-template>
        </button>
      </div>

    </form>
  </div>
</div>
<p-toast></p-toast>
<p-confirmdialog></p-confirmdialog>